import { Entity } from "@rest-hooks/endpoint";
import { BaseResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
import {
	HouseOwner,
	Lien,
	SpecialConstraint,
	Property,
	PropertyTypes
} from "@ploy-lib/types";

class HouseOwnerEntity extends Entity implements HouseOwner {
	readonly houseOwnerId: number = 0;
	readonly dateOfBirth: Date;
	readonly organizationNumber: string = "";
	readonly personalNumber?: string = "";
	readonly name?: string = "";
	readonly email?: string = "";
	readonly phone?: string = "";
	readonly isNorwegianCitizen: boolean = false;
	readonly owningFractionNumerator?: number = 0;
	readonly owningFractionDenominator: number = 0;
	readonly isResident: boolean = false;

	displayValue: string = "";

	pk(parent?: any, key?: string) {
		return this.houseOwnerId.toString();
	}
}

class LienEntity extends Entity implements Lien {
	readonly creditorOrgNo?: string = "";
	readonly creditorName?: string = "";
	readonly priority?: string = "";
	readonly yieldPriority?: boolean = false;
	readonly writtenDownValue?: number = 0;
	readonly propertyId?: string = "";
	readonly addedManually?: boolean | undefined = false;
	readonly lienId?: number = 0;
	readonly documentId?: string = "";
	readonly registrationDate?: Date = new Date();
	readonly lienType?: string = "";
	readonly infoAsText?: string = "";
	readonly value?: number = 0;

	// pk = (): string => this.lienId?.toString() ?? ""; // <-- Kan ikke se slik ut :(

	pk(parent?: any, key?: string) {
		return this.lienId?.toString() ?? "";
	}
}

export class ApplicationPropertiesResource
	extends BaseResource
	implements Property
{
	applicationId: number = 0;
	applicationPropertyId: number = 0;
	propertyId: string = "";
	type: PropertyTypes = "Unknown";
	propertyInformation?: string = "";
	cadastralNumber: string = "";
	municipalityNumber: number = 0;
	cadastralUnitNumber: number = 0;
	unitNumber: number = 0;
	leaseholdUnitNumber: number = 0;
	sectionNumber: number = 0;
	housingCooperativeName: string = "";
	housingCooperativeOrgNumber: string = "";
	housingCooperativeAccountant: string = "";
	shareNumber: number = 0;
	streetName: string = "";
	addressNumber: number = 0;
	addressLetter: string = "";
	postalCode: string = "";
	postalPlace: string = "";
	freeText?: string = "";
	apartmentNumber?: string = "";
	businessManager?: string = "";
	housingCooperativeOrgName?: string = "";
	refinance: boolean = false;
	valueEnteredByCustomer: number = 0;
	ownedByOthers: boolean = false;
	estimatedValue: number = 0;
	jointDebt: number = 0;
	eAppraisal: number = 0;
	pledgeValue?: number = 0;
	utilizedValue: number = 0;
	utilizedSecurityValue: number = 0;
	eAppraisalReference: string = "";
	mainCustomerResidence: boolean = false;
	useType: string = "";
	owners: HouseOwner[] = [];
	liens: LienEntity[] = [];
	specialConstraints: SpecialConstraint[] = [];
	deleted?: boolean | undefined = undefined;

	static schema = {
		liens: [LienEntity],
		owners: [HouseOwnerEntity]
	};

	pk() {
		return this.applicationPropertyId.toString();
	}

	static urlRoot = apiResourceUrl("property/{applicationId}");
}
